import * as React from 'react';
import { addClass, warnOnce, useMergedRefs } from '../../utils';
import './Application.css';
import '../common.css';
import { useId } from '../../utils/hooks/useId';
export var ApplicationTheme;
(function (ApplicationTheme) {
    ApplicationTheme["Light"] = "vai-theme-light";
    ApplicationTheme["Dark"] = "vai-theme-dark";
})(ApplicationTheme || (ApplicationTheme = {}));
function pixelsNotZero(cssStr) {
    return !!cssStr
        .split(' ')
        .map((str) => str.replace(/\D/g, ''))
        .filter((it) => Number(it)).length;
}
export const Application = React.forwardRef((props, ref) => {
    const { htmlId, theme = ApplicationTheme.Light, dataTa, className, children, ...rest } = props;
    const id = useId(htmlId, ['application']);
    const classes = addClass('vai-application', theme, className);
    const localRef = React.useRef();
    React.useEffect(() => {
        const bodyClasses = document.body.classList;
        if (theme === ApplicationTheme.Dark && !bodyClasses.contains(ApplicationTheme.Dark)) {
            document.body.classList.add(theme);
        }
        else if (bodyClasses.contains(ApplicationTheme.Dark)) {
            document.body.classList.remove(ApplicationTheme.Dark);
        }
    }, [theme]);
    React.useEffect(() => {
        if (process.env.NODE_ENV === 'development' && localRef.current && window.document && window.document.body) {
            try {
                const { margin, padding } = window.getComputedStyle(window.document.body);
                if (pixelsNotZero(padding) || pixelsNotZero(margin)) {
                    warnOnce(`Application component expected body to have no margin nor padding. 
Instead got 'margin: ${margin}', and 'padding: ${padding}'`.trim());
                }
            }
            catch (e) {
                console.error('Failed when defining if body has extra margin:', e.message);
            }
        }
    }, [localRef]);
    return (React.createElement("div", Object.assign({ id: id.toString(), "data-ta": dataTa, ref: useMergedRefs(localRef, ref), className: classes }, rest), children));
});
//# sourceMappingURL=Application.js.map